import { c as _c } from "react/compiler-runtime";
import { Icon } from '@petsmart-ui/sparky';
import Highlighter from 'react-highlight-words';
import type { SearchSuggestionItem } from '../../../search.types';
type SuggestionResultProps = {
  item: SearchSuggestionItem;
};
export function SuggestionResult(t0) {
  const $ = _c(16);
  const {
    item
  } = t0;
  const decodedLabel = decodeURIComponent(encodeURI(item.label));
  const t1 = item.kind === "recent" ? "clock-outline" : "search";
  let t2;
  if ($[0] !== t1) {
    t2 = <Icon className="header-search__suggestion-icon" name={t1} aria-hidden="true" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = item.highlight.matchLevel === "none" ? "header-search__text--normal" : "header-search__text--highlighted";
  let t4;
  if ($[2] !== item.highlight.matchedWords) {
    t4 = [...item.highlight.matchedWords];
    $[2] = item.highlight.matchedWords;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== decodedLabel || $[5] !== t3 || $[6] !== t4) {
    t5 = <span className="header-search__suggestion-name"><Highlighter highlightClassName="header-search__text--normal" unhighlightClassName={t3} searchWords={t4} textToHighlight={decodedLabel} /></span>;
    $[4] = decodedLabel;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== item.category) {
    t6 = item.category && !item.category.includes("+") && <span className="header-search__suggestion-category">— in {item.category}</span>;
    $[8] = item.category;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="header-search__suggestion-main">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t7) {
    t8 = <div className="header-search__suggestion">{t2}{t7}</div>;
    $[13] = t2;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}